<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.97269 15.2936C4.16513 13.6727 3.20319 10.0827 4.82414 7.27514C6.43652 4.48241 9.99723 3.51585 12.7981 5.10112C13.1155 5.33504 13.5785 5.72779 13.9577 6.15781C14.155 6.38162 14.3095 6.59297 14.4102 6.77739C14.4637 6.87519 14.4929 6.94882 14.5087 7H12V9H18V3H16V5.54171C15.836 5.28847 15.6476 5.05037 15.4578 4.83508C14.9436 4.25191 14.3387 3.74646 13.9282 3.44993L13.8868 3.42005L13.8426 3.39453C10.0785 1.2213 5.26531 2.51099 3.09208 6.27514C0.918856 10.0393 2.20855 14.8525 5.97269 17.0257C9.73683 19.1989 14.55 17.9092 16.7232 14.1451L14.9912 13.1451C13.3703 15.9527 9.78025 16.9146 6.97269 15.2936Z"
    fill="currentColor"
  />
</svg>
